//default
export const NOTICE = 'notice';

//slice
export const NOTICE_SLICE_NAME = `${NOTICE}Slice`;

// action
export const GET_NOTICE_STATICS = `${NOTICE}`;
export const GET_NOTICES = `${NOTICE}/get`;
export const GET_NOTICE_DETAIL = `${NOTICE}/detail`;
export const CREATE_NOTICE = `${NOTICE}/create`;
export const UPDATE_NOTICE = `${NOTICE}/update`;
export const DELETE_NOTICE = `${NOTICE}/delete`;
export const CREATE_NOTICE_REPLY = `${NOTICE}/reply/create`;
export const UPDATE_NOTICE_REPLY = `${NOTICE}/reply/update`;
export const DELETE_NOTICE_REPLY = `${NOTICE}/reply/delete`;
export const GET_NOTICE_PIC_DOWNLOAD = `${NOTICE}/downloads`;
export const CREATE_NOTICE_ATTACHMENT = `${NOTICE}/attachment/create`;
export const DELETE_NOTICE_ATTACHMENT = `${NOTICE}/attachment/delete`;

// actions
export const actions = {
  GET_NOTICE_STATICS,
  GET_NOTICES,
  GET_NOTICE_DETAIL,
  CREATE_NOTICE,
  UPDATE_NOTICE,
  DELETE_NOTICE,
  CREATE_NOTICE_REPLY,
  UPDATE_NOTICE_REPLY,
  DELETE_NOTICE_REPLY,
  GET_NOTICE_PIC_DOWNLOAD,
  CREATE_NOTICE_ATTACHMENT,
  DELETE_NOTICE_ATTACHMENT
};
